








import Component from 'vue-class-component';
import FormBase from '@/general/abstract/form/FormBase.vue';
import { FormContainer } from '@/common/mixin/FormContainer';
import { FacilityFormModel } from '@/context/facility/model/FacilityFormModel';
import { facilityApi } from '@/context/facility/api/FacilityApi';
import FacilityForm from '@/context/facility/component/FacilityForm.vue';

@Component({
  components: {
    FormBase,
    FacilityForm
  }
})
export default class FacilityFormContainer extends FormContainer<FacilityFormModel> {
  model!: FacilityFormModel;

  async formApi(): Promise<FacilityFormModel> {
    return await facilityApi.form<FacilityFormModel>(
      FacilityFormModel,
      this.$route?.params?.id ? { id: this.$route.params.id } : null
    );
  }
}
